var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3147 0.722272C15.3517 -0.240756 13.7903 -0.240759 12.8273 0.722272L1.18979 12.3598C0.845539 12.704 0.610884 13.1425 0.515409 13.6198L0.0328392 16.0327C-0.197228 17.183 0.816983 18.1973 1.96732 17.9672L4.38016 17.4846C4.85755 17.3892 5.296 17.1545 5.64025 16.8102L17.2777 5.17273C18.2408 4.20971 18.2408 2.64833 17.2777 1.6853L16.3147 0.722272ZM13.9897 1.88475C14.3108 1.56374 14.8312 1.56374 15.1523 1.88475L16.1152 2.84778C16.4363 3.16879 16.4363 3.68924 16.1152 4.01026L13.9192 6.2063L11.7938 4.08079L13.9897 1.88475ZM10.6312 5.24327L2.35227 13.5223C2.23752 13.637 2.1593 13.7832 2.12748 13.9423L1.64491 16.3551L4.05775 15.8725C4.21688 15.8407 4.36303 15.7625 4.47778 15.6478L12.7567 7.36877L10.6312 5.24327Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionEdit);
export default __webpack_public_path__ + "static/media/questionEdit.78424c09784ffd363f0cdd15088991ef.svg";
export { ForwardRef as ReactComponent };